/* UNDENIABLE — product page (PDP2, block-driven info column). Gallery (mobile swipe dots) +
   colour/size variant selection + quantity + add to bag (opens the custom drawer) + CRO widgets
   (viewing count, Klarna line, stock bar, free-shipping progress, ships-today countdown). Config
   is read from the individual block elements so blocks can be reordered/removed freely. Variant
   data comes from [data-pdp-variants] HTML spans (no inline JSON). */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function opt(v, idx) { return idx === 1 ? v.o1 : idx === 2 ? v.o2 : idx === 3 ? v.o3 : null; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re), token = m ? m[1] : 'amount', value;
    switch (token) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'"); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }

  function openDrawer() {
    if (window.UndeniableCart && window.UndeniableCart.open) window.UndeniableCart.open();
    else document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function init(root) {
    if (!root || root.__udnPdp) return;
    root.__udnPdp = true;

    var colorIdx = parseInt(root.getAttribute('data-color-idx'), 10) || 0;
    var sizeIdx = parseInt(root.getAttribute('data-size-idx'), 10) || 0;
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    var variantEls = root.querySelectorAll('[data-pdp-variants] [data-vid]');
    if (!variantEls.length) {
      var vwrap = root.closest('.udn-pdp2') || document;
      variantEls = vwrap.querySelectorAll('[data-pdp-variants] [data-vid]');
    }
    var variants = [].map.call(variantEls, function (el) {
      return {
        id: el.getAttribute('data-vid'),
        o1: el.getAttribute('data-o1'), o2: el.getAttribute('data-o2'), o3: el.getAttribute('data-o3'),
        avail: el.getAttribute('data-avail') === 'true',
        price: el.getAttribute('data-price'),
        cprice: el.getAttribute('data-cprice'),
        badge: el.getAttribute('data-badge') || '',
        klarna: el.getAttribute('data-klarna') || '',
        mid: el.getAttribute('data-mid'),
        sku: el.getAttribute('data-sku')
      };
    });

    var swz = [].slice.call(root.querySelectorAll('.swz [data-color]'));
    var szs = [].slice.call(root.querySelectorAll('.szs [data-size]'));
    var colName = root.querySelector('[data-color-name]');
    var szName = root.querySelector('[data-size-name]');
    var priceEl = root.querySelector('.pdp__pr');
    var klarnaEl = root.querySelector('[data-cro-klarna]');
    var stkWrap = root.querySelector('.stk');
    var stockEl = root.querySelector('[data-stock]');
    var stockIn = stkWrap ? (stkWrap.getAttribute('data-stock-in') || 'In stock') : 'In stock';
    var stockOut = stkWrap ? (stkWrap.getAttribute('data-stock-out') || 'Sold out') : 'Sold out';
    var codeEl = root.querySelector('[data-code]');
    var errEl = root.querySelector('[data-err]');
    var addBtn = root.querySelector('#pdAdd');
    var addLabel = addBtn ? (addBtn.getAttribute('data-add-label') || 'Add to bag') : 'Add to bag';
    var basePrice = addBtn ? (addBtn.getAttribute('data-base-price') || '') : '';
    var addTextEl = addBtn ? addBtn.querySelector('[data-add-text]') : null;
    var qvEl = root.querySelector('[data-qv]');
    var variantInput = root.querySelector('[data-variant-input]');
    var qtyInput = root.querySelector('[data-qty-input]');

    function setAdd(txt) { if (addTextEl) addTextEl.textContent = txt; else if (addBtn) addBtn.textContent = txt; }
    function addDisplay() {
      var v = findVariant();
      if (v && !v.avail) return 'Sold out';
      var price = v ? v.price : basePrice;
      return price ? (addLabel + ' — ' + price) : addLabel;
    }
    var gallery = root.querySelector('.pdp__m');
    var galImgs = gallery ? [].slice.call(gallery.querySelectorAll('img')) : [];

    var state = { color: null, size: null, qty: 1 };
    var pre = root.querySelector('.swz [data-color].on');
    if (pre) { state.color = pre.getAttribute('data-color'); }
    else if (swz.length) {
      /* no color preselected server-side → pick the first colour whose variants are available,
         else the first colour. Prevents every size falsely reading as sold out. */
      var chosen = swz[0];
      for (var ci = 0; ci < swz.length; ci++) {
        var cc = swz[ci].getAttribute('data-color');
        if (variants.some(function (v) { return opt(v, colorIdx) === cc && v.avail; })) { chosen = swz[ci]; break; }
      }
      chosen.classList.add('on');
      state.color = chosen.getAttribute('data-color');
    }

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (colorIdx && opt(v, colorIdx) !== state.color) continue;
        if (sizeIdx && opt(v, sizeIdx) !== state.size) continue;
        return v;
      }
      return null;
    }

    function updateSizeAvailability() {
      if (!sizeIdx) return;
      szs.forEach(function (b) {
        var sv = b.getAttribute('data-size');
        var ok = variants.some(function (v) {
          if (opt(v, sizeIdx) !== sv) return false;
          if (colorIdx && opt(v, colorIdx) !== state.color) return false;
          return v.avail;
        });
        b.classList.toggle('out', !ok);
        b.disabled = !ok;
      });
    }

    function scrollToImage(mid) {
      if (!mid || !gallery) return;
      if (!window.matchMedia || !window.matchMedia('(max-width:900px)').matches) return;
      for (var i = 0; i < galImgs.length; i++) {
        if (galImgs[i].getAttribute('data-mid') === mid) {
          gallery.scrollTo({ left: galImgs[i].offsetLeft, behavior: 'smooth' });
          return;
        }
      }
    }

    function highlightSizeRow(sz) {
      [].forEach.call(root.querySelectorAll('.tbl tr[data-sz]'), function (tr) {
        tr.classList.toggle('on', tr.getAttribute('data-sz') === sz);
      });
    }

    function render() {
      var v = findVariant();
      if (colName) colName.textContent = state.color || 'Select';
      if (szName) szName.textContent = state.size || 'Select';
      if (v && priceEl) {
        var html = '<span>' + v.price + '</span>';
        if (v.badge) html += '<s>' + v.cprice + '</s><em>' + v.badge + '</em>';
        priceEl.innerHTML = html;
      }
      if (v && klarnaEl && v.klarna) klarnaEl.textContent = v.klarna;
      if (v && codeEl && v.sku) codeEl.textContent = v.sku;
      if (stockEl && v) stockEl.textContent = v.avail ? stockIn : stockOut;
      if (addBtn) {
        if (v && !v.avail) {
          addBtn.disabled = true; addBtn.removeAttribute('data-variant-id');
        } else {
          addBtn.disabled = false;
          if (v) addBtn.setAttribute('data-variant-id', v.id); else addBtn.removeAttribute('data-variant-id');
        }
        setAdd(addDisplay());
      }
      if (variantInput && v) variantInput.value = v.id;
    }

    swz.forEach(function (b) {
      b.addEventListener('click', function () {
        swz.forEach(function (o) { o.classList.remove('on'); });
        b.classList.add('on');
        state.color = b.getAttribute('data-color');
        updateSizeAvailability();
        scrollToImage(b.getAttribute('data-mid'));
        render();
      });
    });

    szs.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('out') || b.disabled) return;
        szs.forEach(function (o) { o.classList.remove('on'); });
        b.classList.add('on');
        state.size = b.getAttribute('data-size');
        if (errEl) errEl.classList.remove('on');
        highlightSizeRow(state.size);
        render();
      });
    });

    root.querySelectorAll('.qbox [data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty + (parseInt(b.getAttribute('data-q'), 10) || 0));
        if (qvEl) qvEl.textContent = state.qty;
        if (qtyInput) qtyInput.value = state.qty;
      });
    });

    var sg = root.querySelector('#pdSg');
    if (sg) {
      sg.addEventListener('click', function () {
        var acc = root.querySelector('[data-size-acc] .acc__q');
        if (!acc) return;
        var it = acc.closest('.acc__i');
        if (it && !it.classList.contains('on')) acc.click();
        acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ── mobile gallery dots ── */
    var dotsWrap = root.querySelector('[data-dots]');
    if (dotsWrap && gallery && galImgs.length > 1) {
      galImgs.forEach(function (im, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.setAttribute('aria-label', 'Image ' + (i + 1));
        if (i === 0) d.className = 'on';
        d.addEventListener('click', function () { gallery.scrollTo({ left: im.offsetLeft, behavior: 'smooth' }); });
        dotsWrap.appendChild(d);
      });
      var dots = [].slice.call(dotsWrap.children);
      gallery.addEventListener('scroll', function () {
        var sl = gallery.scrollLeft, best = 0, bestd = Infinity;
        galImgs.forEach(function (im, i) { var d = Math.abs(im.offsetLeft - sl); if (d < bestd) { bestd = d; best = i; } });
        dots.forEach(function (d, i) { d.classList.toggle('on', i === best); });
      }, { passive: true });
    }

    /* ── free-shipping bar ── */
    function refreshShip() {
      var ship = root.querySelector('[data-ship]');
      if (!ship) return;
      var bar = ship.querySelector('[data-ship-bar]');
      var txt = ship.querySelector('[data-ship-text]');
      var threshold = (parseFloat(ship.getAttribute('data-threshold')) || 0) * 100;
      if (threshold <= 0) return;
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = cart.total_price || 0;
          var remaining = threshold - total;
          var progress = Math.max(0, Math.min(1, total / threshold));
          if (bar) bar.style.right = (100 - progress * 100) + '%';
          if (txt) {
            if (remaining <= 0) txt.textContent = ship.getAttribute('data-unlocked') || 'Free shipping unlocked';
            else txt.innerHTML = 'You are <b>' + formatMoney(remaining, moneyFormat) + '</b> ' + (ship.getAttribute('data-away') || '');
          }
        }).catch(function () {});
    }

    /* ── add to bag ── */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (sizeIdx && !state.size) { if (errEl) errEl.classList.add('on'); return; }
        var id = addBtn.getAttribute('data-variant-id');
        if (!id) { var v = findVariant(); id = v && v.id; }
        if (!id) return;
        addBtn.disabled = true; addBtn.classList.add('on');
        setAdd('Adding…');
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: state.qty }] })
        }).then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.status) { throw new Error(data.description || 'add failed'); }
            setAdd('Added');
            openDrawer();
            refreshShip();
            setTimeout(function () { addBtn.disabled = false; addBtn.classList.remove('on'); setAdd(addDisplay()); }, 1100);
          })
          .catch(function () { addBtn.disabled = false; addBtn.classList.remove('on'); setAdd(addDisplay()); });
      });
    }

    /* ── viewing count gentle jitter ── */
    var viewEl = root.querySelector('[data-cro-view]');
    if (viewEl) {
      var base = parseInt(viewEl.textContent, 10) || 12;
      setInterval(function () {
        viewEl.textContent = Math.max(5, base + Math.round((Math.random() - 0.5) * 4));
      }, 7000);
    }

    /* ── ships-today countdown + delivery estimate ── */
    var cd = root.querySelector('[data-countdown]');
    if (cd) {
      var clockEl = cd.querySelector('[data-cro-clock]');
      var etaEl = cd.querySelector('[data-cro-eta]');
      var whenEl = cd.querySelector('[data-cro-when]');
      var cutoff = (cd.getAttribute('data-cutoff') || '14:00').split(':');
      var ch = parseInt(cutoff[0], 10) || 14, cm = parseInt(cutoff[1], 10) || 0;
      var dmin = parseInt(cd.getAttribute('data-min'), 10); if (isNaN(dmin)) dmin = 2;
      var dmax = parseInt(cd.getAttribute('data-max'), 10); if (isNaN(dmax)) dmax = 4;
      var fmtDate = function (d) { return WD[d.getDay()] + ' ' + d.getDate() + ' ' + MO[d.getMonth()]; };
      var addDays = function (d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; };
      var tick = function () {
        var now = new Date();
        var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), ch, cm, 0);
        var shipsToday = now < target;
        if (!shipsToday) target = addDays(target, 1);
        if (whenEl) whenEl.textContent = shipsToday ? 'today' : 'tomorrow';
        if (clockEl) {
          var diff = Math.max(0, Math.floor((target - now) / 1000));
          clockEl.textContent = pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
        }
        if (etaEl) {
          var dispatch = shipsToday ? now : addDays(now, 1);
          var lo = addDays(dispatch, dmin), hi = addDays(dispatch, dmax);
          etaEl.textContent = dmin === dmax ? fmtDate(lo) : (fmtDate(lo) + ' – ' + fmtDate(hi));
        }
      };
      tick();
      setInterval(tick, 1000);
    }

    if (state.size) highlightSizeRow(state.size);
    updateSizeAvailability();
    render();
    refreshShip();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-pdp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
